import { InvitesActionType, INVITE_PROP } from "./constants";

export const getDefaultState = () => ({
  table: {
    orderBy: {
      col: INVITE_PROP.EMAIL,
      order: "asc",
    },
    search: "",
    limit: 10,
    offset: 0,
    filters: [],
  },
  breakDown: { count: 0 },
  invites: [],
  total: 0,
  editInvite: {},
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case InvitesActionType.SET_INVITES:
      return setInvitesData(state, action);
    case InvitesActionType.SET_EDIT_INVITE:
      return setEditInvite(state, action);
    case InvitesActionType.SET_ORDER_BY:
      return setOrderBy(state, action);
    case InvitesActionType.SET_PAGING_OPT:
      return setPagingOptions(state, action);
    case InvitesActionType.SET_PAGE_OFFSET:
      return setPagingOffset(state, action);
    case InvitesActionType.SET_FILTER:
      return setFilter(state, action);
    case InvitesActionType.SET_SEARCH_TEXT:
      return setSearchText(state, action);
    case InvitesActionType.SET_BREAK_DOWN:
      return setBreakdown(state, action);
    default:
      return state;
  }
};

const setInvitesData = (state, { invites }) => {
  return {
    ...state,
    invites: invites.rows,
    total: invites.total,
  };
};

const setEditInvite = (state, { data }) => {
  return {
    ...state,
    editInvite: data,
  };
};
function setSearchText(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      search: action.search,
    },
  };
}

function setFilter(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      filters: action.filters,
    },
  };
}

function setPagingOffset(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      offset: action.offset,
    },
  };
}

function setPagingOptions(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      limit: action.paging.limit,
      offset: action.paging.offset,
    },
  };
}

function setOrderBy(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      orderBy: action.orderBy,
    },
  };
}

function setBreakdown(state, { breakDown }) {
  return {
    ...state,
    breakDown,
  };
}
